import { viperApi } from '@/services/viper-api'

export const apiVersionService = {
  get() {
    return viperApi.get('/../actuator/info').then(r => r.data)
  }
}
